import { render, staticRenderFns } from "./tabitha-print.vue?vue&type=template&id=7873a550&scoped=true&"
import script from "./tabitha-print.vue?vue&type=script&lang=js&"
export * from "./tabitha-print.vue?vue&type=script&lang=js&"
import style0 from "./tabitha-print.vue?vue&type=style&index=0&id=7873a550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7873a550",
  null
  
)

export default component.exports